import { createComparator } from '@tmapy/beetlejuice-utils';

type QueryArg = string | number | null | undefined | QueryArg[];

export type QueryArgs = Record<string, QueryArg>;

const stableArgsSorter = createComparator<[string, string]>(
  ([key]) => key,
  ([_, val]) => val,
);

export function queryArgs(query?: QueryArgs | null): string {
  if (!query) return '';

  const arr: [string, string][] = [];
  const addValue = (key: string, val: QueryArg) => {
    if (val === null || typeof val === 'undefined') return;

    if (Array.isArray(val)) {
      val.forEach((v) => addValue(key, v));
    } else {
      arr.push([key, val.toString()]);
    }
  };

  for (const [key, val] of Object.entries(query)) {
    addValue(key, val);
  }

  if (arr.length === 0) return '';
  arr.sort(stableArgsSorter);

  return (
    '?' + arr.map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join('&')
  );
}

/**
 * Filtr v reduxu drží i prázdné hodnoty (zůstanou po vyčištění formuláře).
 * Do dotazu je nepouštíme, aby se cesta resource shodovala s nefiltrovanou
 * a aby invalidace z detailu trefila stejný klíč, pod kterým cachuje přehled.
 */
export function stripEmptyFilters<T extends object>(filters: T): T {
  const query: Record<string, unknown> = {};
  for (const [key, val] of Object.entries(filters)) {
    if (typeof val !== 'undefined' && val !== '') {
      query[key] = val;
    }
  }
  return query as T;
}
